(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/accessibility/assets/javascripts/behaviors/keyboard-navigation.js') >= 0) return;  svs.modules.push('/components/numbergames/accessibility/assets/javascripts/behaviors/keyboard-navigation.js');

'use strict';

svs.numbergames.accessibility.behaviors.KeyboardNavigation = Marionette.Behavior.extend({
  navigationActive: false,
  ui: {
    keyboardNav: '.js-numbergames-keyboard-nav'
  },
  triggers: {
    'keydown @ui.keyboardNav': {
      event: 'keydown',
      preventDefault: false,
      stopPropagation: false
    }
  },
  onKeydown(view, event) {
    const activate = 'activateTabNavigation';
    const inactivate = 'inactivateTabNavigation';
    let action;
    switch (event.key) {
      case 'Enter':
        action = this.navigationActive ? inactivate : activate;
        break;
      case ' ':
        action = activate;
        break;
      case 'Escape':
        action = inactivate;
        break;
      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowLeft':
      case 'ArrowRight':
        action = 'arrowKeyNavigation';
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.view.triggerMethod(action, event);
  },
  onActivateTabNavigation() {
    this.navigationActive = true;
  },
  onInactivateTabNavigation() {
    this.navigationActive = false;
  }
});

 })(window);